<template>
  <div>
    <apexchart type="pie" :options="options" :series="series" :width="largura"></apexchart>
    {{preencherGrafico}}
  </div>
</template>
<script>
/* eslint-disable */
import VueApexCharts from "vue-apexcharts";
import Dexie from "dexie";
import BibliotecaDeCalculos from "bibliotecadecalculos-f02";
import DadosRecursosPastagensOutros from "../../class/DadosRecursosPastagensOutros.js";
import DadosRecursosInstalacoes from "../../class/DadosRecursosInstalacoes.js";
import DadosRecursosMaquinas from "../../class/DadosRecursosMaquinas.js";
import DadosRecursosAnimais from "../../class/DadosRecursosAnimais.js";
import DadosRebanhoReproducao from "../../class/RebanhoDeReproducao.js";
import DadosDespesasAnimal from "../../class/DadosDespesasAnimal.js";
import DadosDasDespesas from "../../class/DadosDasDespesas.js";
import DadosDespesasManutencao from "../../class/DadosDespesasManutencao.js";
import DadosDespesasServicos from "../../class/DadosDespesasServicos";

export default {
  components: {
    apexchart: VueApexCharts
  },
  data: () => ({
    options: {
      legend: {
        position: "top"
      },
      colors: [
        "#BF343F",
        "#128BA6"
      ],
      labels: [
        "Juros sobre capital circulante",
        "Juros sobre capital imobilizado"
      ],
       dataLabels: {
        enabled: true,
        formatter: function(val, opts) {
          return (parseFloat(opts.w.config.series[opts.seriesIndex].toFixed(2))).toLocaleString("pt-BR", {style: 'currency', currency: 'BRL'});
        }
      },
      tooltip: {
        y: {
          formatter: function(val) {
            var valor = val
            if(typeof valor !== "undefined")
            {
              return (parseFloat(valor.toFixed(2))).toLocaleString("pt-BR", {style: 'currency', currency: 'BRL'});
            }else 
              return valor
          } 
        }
      }
    },
    series: [0, 0],
    largura: "100%",
    comprimento: "200%",
    formulario: "",
    simulation: ''
  }),

  mounted() {
    var self = this;
    this.$db.simulation.get(this.$route.params.code, function(s) {
      self.simulation = s;
    });
  },
  computed:{
    preencherGrafico: function() {
      this.$db.simulation.get({ code: this.simulation.code }, dado => {
        var pastagens = new DadosRecursosPastagensOutros(dado.dadosRecursosPastagensOutros);
        var instalacoes = new DadosRecursosInstalacoes(dado.dadosRecursosInstalacoes);
        var maquinas = new DadosRecursosMaquinas(dado.dadosRecursosMaquinas);
        var recursosAnimais = new DadosRecursosAnimais(dado.dadosRecursosAnimais);
        var rebanhoReproducao = new DadosRebanhoReproducao(dado.rebanhoReproducao);
        var despesasAnimais = new DadosDespesasAnimal(dado.dadosDespesasAnimal);
        var despesas = new DadosDasDespesas(dado.dadosDasDespesas);
        var manutencao = new DadosDespesasManutencao(dado.dadosManutencao);
        var servicos = new DadosDespesasServicos(dado.dadosDespesasServicos);

        var biblioteca = [
            BibliotecaDeCalculos.RecursosPastagens(pastagens),
            BibliotecaDeCalculos.RecursosInstalacoes(instalacoes),
            BibliotecaDeCalculos.RecursosMaquinas(maquinas),
            BibliotecaDeCalculos.RecursosAnimais(recursosAnimais),
            BibliotecaDeCalculos.DespesasAnimais(despesasAnimais),
            BibliotecaDeCalculos.Despesas(despesas),
            BibliotecaDeCalculos.DespesasManutencao(manutencao, BibliotecaDeCalculos.RecursosInstalacoes(instalacoes), BibliotecaDeCalculos.RecursosMaquinas(maquinas)),
            BibliotecaDeCalculos.DespesasServicos(servicos),
            BibliotecaDeCalculos.CalculosDosGraficos(BibliotecaDeCalculos.RecursosPastagens(pastagens), BibliotecaDeCalculos.RecursosInstalacoes(instalacoes),
            BibliotecaDeCalculos.RecursosMaquinas(maquinas), BibliotecaDeCalculos.RecursosAnimais(recursosAnimais), BibliotecaDeCalculos.RebanhoDeReproducao(rebanhoReproducao), BibliotecaDeCalculos.DespesasAnimais(despesasAnimais),
            BibliotecaDeCalculos.Despesas(despesas), "", BibliotecaDeCalculos.DespesasManutencao(manutencao, BibliotecaDeCalculos.RecursosInstalacoes(instalacoes), BibliotecaDeCalculos.RecursosMaquinas(maquinas)), BibliotecaDeCalculos.DespesasServicos(servicos), "", "", "")
        ];

        return biblioteca;
      })
      .then(
        g => (
          (this.series[0] = g[8].jurosCapitalCirculante()),
          (this.series[1] = g[8].jurosCapitalImobilizado())
        )
      );
    }
  }
};
</script>
<style scoped>
</style>